module.exports = __webpack_public_path__ + "static/intro-background-b1d08a46d708ed18049146cce0ce0283.jpg";